import { logoPrincipal } from '../assets';
import { useEffect, useRef, useState } from 'react';

// ✅ “halo” por variante (igual que Process.jsx)
const NEON_VARIANTS = {
  green: {
    ring: 'ring-1 ring-lime-400/35',
    halo: 'shadow-[0_0_55px_rgba(163,230,53,0.22),0_0_85px_rgba(34,197,94,0.16)]',
    bar: 'bg-gradient-to-r from-lime-400 via-emerald-400 to-lime-300',
    barShadow: 'shadow-[0_0_16px_rgba(163,230,53,0.55),0_0_18px_rgba(34,197,94,0.35)]',
    sysText: 'text-lime-300',
    hoverTitle: 'group-hover:text-lime-300',
  },
  orange: {
    ring: 'ring-1 ring-orange-400/35',
    halo: 'shadow-[0_0_55px_rgba(249,115,22,0.22),0_0_85px_rgba(251,146,60,0.16)]',
    bar: 'bg-gradient-to-r from-orange-400 via-amber-400 to-orange-300',
    barShadow: 'shadow-[0_0_16px_rgba(249,115,22,0.55),0_0_18px_rgba(251,146,60,0.35)]',
    sysText: 'text-orange-300',
    hoverTitle: 'group-hover:text-orange-300',
  },
  magenta: {
    ring: 'ring-1 ring-fuchsia-400/35',
    halo: 'shadow-[0_0_55px_rgba(217,70,239,0.22),0_0_85px_rgba(236,72,153,0.16)]',
    bar: 'bg-gradient-to-r from-fuchsia-500 via-pink-500 to-fuchsia-400',
    barShadow: 'shadow-[0_0_16px_rgba(217,70,239,0.50),0_0_18px_rgba(236,72,153,0.32)]',
    sysText: 'text-fuchsia-400',
    hoverTitle: 'group-hover:text-fuchsia-400',
  },
};

// ✅ decide variante por item (P3 magenta; el resto alterna)
const getVariantForItem = (item, index) => {
  if (item.number === '03') return NEON_VARIANTS.magenta;
  return index % 2 === 0 ? NEON_VARIANTS.green : NEON_VARIANTS.orange;
};

const ITEMS = [
  {
    number: '01',
    pillar: 'Pilar 1',
    title: 'Next Global Media',
    description: 'Cómo podemos ayudarte a impulsar tu marca?.',
    cta: { label: 'Explorar Servicios', href: '#services' },
    primary: true,
  },
  {
    number: '02',
    pillar: 'Pilar 2',
    title: 'Imperio Digital IA',
    description:
      'Inteligencia Artificial aplicada a ingresos y negocios inteligentes.',
    cta: { label: 'Conocer Más', href: '#services' },
  },
  {
    number: '03',
    pillar: 'Pilar 3',
    title: 'Comunidad de Ofertas Amazon',
    description:
      'Aquí encontrarás ofertas exclusivas para comprar en Amazon con descuento.Te ayudamos a atraer personas, crear una comunidad fiel y generar ingresos dentro de Amazon.',
    note: '“Cada unidad opera de forma independiente, pero se conecta estratégicamente para generar crecimiento sostenido.”',
    cta: { label: 'Visitanos', href: ' https://ahorrandoconnathy.click' },
  },
];

const FlowCard = ({ item, isVisible, delay = 0, variant, emphasis = false }) => {
  const wrapperClasses = [
    'group process-panel rounded-[2rem] p-10',
    'flex flex-col justify-end relative overflow-hidden',
    'transform transition-all duration-[1200ms] ease-out hover:z-20',
    isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10',
    emphasis
      ? `ring-1 ring-primary/35 shadow-[0_0_70px_rgba(54,98,226,0.22),0_0_95px_rgba(54,98,226,0.16)]`
      : '',
    !emphasis ? `${variant.ring} ${variant.halo}` : '',
  ].join(' ');

  return (
    <div className={wrapperClasses} style={{ transitionDelay: `${delay}ms` }}>
      <span className="frosted-number">{item.number}</span>

      <div className="relative z-20">
        <div
          className={[
            'w-16 h-1 mb-6',
            emphasis
              ? 'bg-gradient-to-r from-primary via-fuchsia-500 to-orange-400 shadow-[0_0_18px_rgba(54,98,226,0.45),0_0_18px_rgba(217,70,239,0.25),0_0_18px_rgba(249,115,22,0.20)]'
              : `${variant.bar} ${variant.barShadow}`,
          ].join(' ')}
        />

        <h3
          className={[
            'text-3xl md:text-[2.1rem] font-display font-black text-secondary dark:text-slate-100 uppercase tracking-wider mb-4 transition-colors',
            emphasis ? 'group-hover:text-primary' : variant.hoverTitle,
          ].join(' ')}
        >
          {item.title}
        </h3>

        <p className="text-slate-500 dark:text-slate-300 font-light leading-relaxed text-base text-justify">
          {item.description}
        </p>

        <div className="mt-8">
          <button
            onClick={() => {
              const url = item.cta.href;
              console.log('Navegando a:', url);
              if (url.startsWith('http')) {
                window.open(url, '_blank');
              } else {
                window.location.href = url;
              }
            }}
            className="inline-flex items-center justify-center gap-3 rounded-2xl px-7 py-4 text-xs font-black tracking-[0.22em] uppercase bg-primary text-white hover:bg-[#2D54C7] transition-colors shadow-[0_0_32px_rgba(54,98,226,0.35)]"
          >
            {item.cta.label}
            <span className="material-symbols-outlined text-sm">arrow_forward</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default function EcosystemFlow() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          io.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    io.observe(el);
    return () => io.disconnect();
  }, []);

  const primary = ITEMS.find((i) => i.primary) ?? ITEMS[0];
  const left = ITEMS.find((i) => i.number === '02') ?? ITEMS[1];
  const right = ITEMS.find((i) => i.number === '03') ?? ITEMS[2];

  return (
    <section
      ref={sectionRef}
      className="pt-20 pb-16 relative overflow-hidden bg-[#EEF2F7] dark:bg-slate-950"
      id="ecosystem"
    >
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-[0.03] dark:opacity-[0.02] z-0 mix-blend-multiply dark:mix-blend-normal" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] bg-primary/5 dark:bg-primary/10 blur-[140px] rounded-full z-0" />

      <img
        src={logoPrincipal}
        alt=""
        className="absolute inset-0 w-full h-full object-contain opacity-[0.06] dark:opacity-[0.10] z-0 pointer-events-none"
        style={{
          transform: 'scale(1.25)',
          filter: 'grayscale(1) contrast(1.05)',
        }}
      />
      <div className="absolute inset-0 bg-white/10 dark:bg-black/20 z-0 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div
          className={[
            'mb-24 text-center transform transition-all duration-[1200ms] ease-out',
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6',
          ].join(' ')}
        >
          <h2 className="text-5xl md:text-7xl font-display font-bold mt-6 text-secondary dark:text-slate-100 tracking-tight">
            NUESTRAS MARCAS
          </h2>

          <p className="text-slate-500 dark:text-slate-300 mt-4 font-light text-lg">
            Dentro de Next Global Media contamos con marcas independientes, cada una especializada en ayudarte a generar más ingresos, optimizar tu trabajo y hacer crecer tu negocio digital. Aunque operan por separado, trabajan juntas estratégicamente para impulsarte más rápido y con mejores resultados.
          </p>
        </div>

        {/* ✅ Desktop: ahora subimos las cards reduciendo el "canvas" y moviendo el top */}
        <div className="hidden lg:block">
          {/* antes: height 980 -> ahora 680 (menos espacio vacío) */}
          <div className="relative mx-auto w-full max-w-[1280px]" style={{ height: 680 }}>
            {/* antes: top-[720px] -> ahora top-[360px] */}
            <div className="absolute left-[360px] top-[360px] -translate-x-1/2 -translate-y-1/2 z-10 w-[520px]">
              <FlowCard
                item={left}
                isVisible={isVisible}
                delay={280}
                variant={getVariantForItem(left, 1)}
              />
            </div>

            <div className="absolute left-[920px] top-[360px] -translate-x-1/2 -translate-y-1/2 z-10 w-[520px]">
              <FlowCard
                item={right}
                isVisible={isVisible}
                delay={440}
                variant={getVariantForItem(right, 2)}
              />
            </div>
          </div>
        </div>

        {/* ✅ Mobile/Tablet: cards centradas (stack) */}
        <div className="lg:hidden">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-16 place-items-center">
            {ITEMS.filter((item) => !item.primary).map((item, index) => {
              const variant = getVariantForItem(item, index);

              return (
                <div key={item.number} className={index % 2 === 1 ? 'md:translate-y-6' : ''}>
                  <div className="w-full max-w-[620px]">
                    <FlowCard
                      item={item}
                      isVisible={isVisible}
                      delay={index * 180}
                      variant={variant}
                      emphasis={Boolean(item.primary)}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}